"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickerReservationStatus = void 0;
var TickerReservationStatus;
(function (TickerReservationStatus) {
    /**
     * ticker hasn't been reserved or previous reservation expired
     */
    TickerReservationStatus["Free"] = "Free";
    /**
     * ticker is currently reserved
     */
    TickerReservationStatus["Reserved"] = "Reserved";
    /**
     * an Asset using this ticker has already been created
     */
    TickerReservationStatus["AssetCreated"] = "AssetCreated";
})(TickerReservationStatus = exports.TickerReservationStatus || (exports.TickerReservationStatus = {}));
//# sourceMappingURL=types.js.map